import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubbleWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bubble-wide, message, chat"><path d="M5.75 3C3.67893 3 2 4.67893 2 6.75V15.25C2 17.3211 3.67893 19 5.75 19H8.65182C8.71055 19 8.76741 19.0207 8.81242 19.0584L10.8775 20.7894C11.5249 21.3321 12.4676 21.3348 13.1181 20.7959L15.2164 19.0575C15.2613 19.0203 15.3177 19 15.3759 19H18.25C20.3211 19 22 17.3211 22 15.25V6.75C22 4.67893 20.3211 3 18.25 3H5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBubbleWide;
